<template>
  <div class="page">
    <div class="page-title">Order History</div>
    <div class="page-content">
      <loading-panel :loading="loading" class="w-100">
        <h2 class="text-center">My Orders</h2>
        <div class="table table-hover table-striped table-thick w-100">
          <v-data-table class="w-100" :headers="headers" :items="orders">
            <template v-slot:item.id="{ item }">{{
              item.id + $consts.ORDER_NUM_BASE
            }}</template>
            <template v-slot:item.price="{ item }"
              >${{ item.price.toFixed(2) }}</template
            >
            <template v-slot:item.updatedAt="{ item }">
              <a :href="`/#/orders/${item.id}`">
                <button class="btn small-btn">
                  <i class="fa fa-search-dollar"></i> View
                </button>
              </a>
            </template>
          </v-data-table>
        </div>
        <error-panel class="m-auto text-center" :errors="errors"></error-panel>
      </loading-panel>
    </div>
  </div>
</template>

<script>
import consts from "@/consts.ts";

export default {
  name: "companies",
  components: {},
  data: () => ({
    loading: false,
    headers: [
      { text: "Confirmation #", align: "center", value: "id" },
      { text: "Date", align: "center", value: "createdAt" },
      { text: "Price", align: "center", value: "price" },
      { text: "", align: "center", value: "updatedAt", sortable: false },
    ],
    orders: [],
    errors: [],
  }),
  methods: {},
  async mounted() {
    try {
      this.loading = true;
      const response = await this.$web.getOrdersForUser();
      if (response.data.orders && response.data.orders.length > 0) {
        this.orders = response.data.orders;
      } else {
        this.errors = ["No orders found."];
      }
    } catch (err) {
      console.log(err);
      this.errors = ["An error occurred."];
    } finally {
      this.loading = false;
    }
  },
};
</script>

<style lang="scss" scoped>
.my-orders {
  padding: 20px;
  max-width: 768px;
}

.table {
  display: flex;
  justify-content: center;
}

tr {
  padding: 20px !important;
}
</style>
